module.exports = __webpack_public_path__ + "img/developer-2.39f14499.png";